import TemaInngangListeBlock from './TemaInngangListeBlock';

globalThis.TemaInngangListeComponents = {
  TemaInngangListeBlock,
};
